
import React from 'react';
import { Eye, ThumbsUp, MessageSquare, ListPlus, Share, Zap } from 'lucide-react';

interface StatItemProps {
  icon: React.ReactNode;
  title: string;
  description: string;
  value: string | number;
  iconColor?: string;
}

export const StatItem: React.FC<StatItemProps> = ({ 
  icon, 
  title, 
  description, 
  value,
  iconColor = "text-blue-500"
}) => {
  return (
    <div className="border rounded-md p-4">
      <div className={`flex items-center gap-2 mb-2`}>
        <span className={iconColor}>{icon}</span>
        <span className="font-medium">{title}</span>
      </div>
      <div className="flex justify-between items-end">
        <p className="text-sm text-gray-500">{description}</p>
        <span className="text-2xl font-bold text-slate-700">{value}</span>
      </div>
    </div>
  );
};

export const VideoStatsGrid: React.FC = () => {
  return (
    <div className="grid grid-cols-2 gap-4 mb-8">
      <StatItem
        icon={<Eye className="h-5 w-5" />}
        title="Vues de vidéos"
        description="Nombre d'utilisateurs qui ont vu cette vidéo"
        value={760}
        iconColor="text-orange-500"
      />
      
      <StatItem
        icon={<ThumbsUp className="h-5 w-5" />}
        title="J'aime"
        description="Nombre de j'aime sur cette vidéo"
        value={15}
        iconColor="text-blue-500"
      />
      
      <StatItem
        icon={<MessageSquare className="h-5 w-5" />}
        title="Commentaires"
        description="Nombre de commentaires sur cette vidéo"
        value={6}
        iconColor="text-purple-500"
      />
      
      <StatItem
        icon={<ListPlus className="h-5 w-5" />}
        title="Ajouté à une playlist"
        description="Nombre de fois où cette vidéo a été ajoutée à une playlist"
        value={0}
        iconColor="text-indigo-500"
      />
      
      <StatItem
        icon={<Share className="h-5 w-5" />}
        title="Partage"
        description="Nombre de fois où cette vidéo a été partagée"
        value={0}
        iconColor="text-green-500"
      />
      
      <StatItem
        icon={<Zap className="h-5 w-5" />}
        title="Total engagement"
        description="Nombre d'interactions avec cette vidéo"
        value={21}
        iconColor="text-amber-500"
      />
    </div>
  );
};

interface RoiStatItemProps {
  title: string;
  available?: boolean;
}

export const RoiStatItem: React.FC<RoiStatItemProps> = ({ title, available = false }) => {
  return (
    <div className="border rounded-md p-4">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="h-5 w-5 text-gray-500"><path d="M3 3v18h18"/><path d="M18.4 15.4c-1.2.8-2.6 1.1-4 .9-1.4-.2-2.6-1-3.4-2.1-1.4-2-1.4-5 .1-7 .7-1 1.9-1.6 3.1-1.7 1.3-.1 2.6.5 3.4 1.6"/><path d="m15 7 2 3 3-2"/></svg>
          <span className="font-medium">{title}</span>
        </div>
        <span className="text-lg font-bold">—</span>
      </div>
      <p className="text-sm text-gray-500">
        Données non disponibles
      </p>
    </div>
  );
};

export const VideoRoiStatsGrid: React.FC = () => {
  return (
    <div className="grid grid-cols-2 gap-4">
      <RoiStatItem title="Clics Uniques" />
      <RoiStatItem title="Objectifs réalisés" />
      <RoiStatItem title="Valeur des objectifs réalisés" />
      <RoiStatItem title="Transactions" />
      <RoiStatItem title="Revenus générés" />
    </div>
  );
};
